export default {
  api: {
    baseUrl: process.env.VUE_APP_API_BASE_URL,
  }
}
